import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrImage({
  value,
  label,
  size = 240,
  downloadName,
}: {
  value: string;
  label: string;
  size?: number;
  downloadName?: string;
}) {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let active = true;
    QRCode.toDataURL(value, {
      width: size,
      margin: 2,
      errorCorrectionLevel: "M",
      color: { dark: "#111827", light: "#ffffff" },
    }).then((dataUrl) => active && setSrc(dataUrl));
    return () => {
      active = false;
    };
  }, [size, value]);

  if (!src) return <div className="qr-placeholder" aria-label="กำลังสร้าง QR Code" />;
  return (
    <>
      <img className="qr-image" src={src} width={size} height={size} alt={label} />
      {downloadName && (
        <a className="qr-download" href={src} download={downloadName}>
          ดาวน์โหลด QR เป็น PNG
        </a>
      )}
    </>
  );
}
